var LINK_PREVIEW_URLS = {
    get_preview_data: "https://jsonlink.io/api/extract",
};

export { LINK_PREVIEW_URLS };
//# sourceMappingURL=LinkPreview.constants.js.map
